module.exports = __webpack_public_path__ + "static/media/alex-win.6a59e991.png";